/*
 *   Copyright (c) 2022 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
import { Component, OnInit, Output, EventEmitter } from "@angular/core";
import { DialogService } from "src/app/services/dialog-service/dialog.service";
import { ProfileComponent } from "src/app/features/user/profile/profile.component";
import { ChangePasswordComponent } from "../../auth-feature/change-password/change-password.component";
import { isSRSMFlag } from "src/environments/config";
import { LocalStorageService } from "src/app/services/shared/local-storage/local-storage.service";
import { storeText } from "src/environments/config";
import { StoresService } from "src/app/services/catalog/stores.service";
import { SlotService } from "src/app/services/slot/slot.service";
import { Router } from "@angular/router";
import { QuotationsService } from "src/app/services/quotations/quotations.service";

@Component({
  selector: "app-side-nav-list",
  templateUrl: "./side-nav-list.component.html",
  styleUrls: ["./side-nav-list.component.scss"],
})
export class SideNavListComponent implements OnInit {
  @Output() closeNavBar: EventEmitter<any> = new EventEmitter();
  isLoggedInUser = false;
  isCustomer = true;
  isSupplier = false;
  user;
  public isAppointment = true;
  public isCheckoutEnabled = false;
  public isCatalog = true;
  public isQuotation = true;
  public storeText = storeText.text;
  showWishList = false;
  constructor(
    public dialogService: DialogService,
    public localStorageService: LocalStorageService,
    private slotService: SlotService,
    public router: Router,
    public storesService: StoresService,
    public quotationsService: QuotationsService
  ) {}

  ngOnInit() {
    this.localStorageService.getConfig();
    if (
      localStorage.getItem("nVipaniwhiteshopkey") ||
      localStorage.getItem("retailerToken")
    ) {
      this.isLoggedInUser = true;
      const config = JSON.parse(localStorage.getItem("companyConfig"));
      if (config.whiteshop) {
        this.isCatalog = config.whiteshop.catalogueAccessToSalesperson;
        this.isQuotation = config.whiteshop.isQuotations;
        this.isAppointment = config.whiteshop.isScheduledAppointmentsEnabled;
        this.isCheckoutEnabled = config.whiteshop.isCheckoutProcessEnabled;
      }
    }
    if (isSRSMFlag.flag) {
      if (
        localStorage.getItem("isSupplier") &&
        JSON.parse(localStorage.getItem("isSupplier"))
      ) {
        this.isSupplier = true;
      } else {
        this.isSupplier = false;
      }
    }
    this.isCustomer = !Boolean(localStorage.getItem("retailerToken"));
    const config = JSON.parse(
      localStorage.getItem("companyConfig")
        ? localStorage.getItem("companyConfig")
        : localStorage.getItem("config")
    );
    this.showWishList =
      config.whiteshop.enableWishlist &&
      localStorage.getItem("user") &&
      JSON.parse(localStorage.getItem("user")).type === "B2C";
  }

  closeNav(type?: string) {
    switch (type) {
      case "quotations":
        this.quotationsService.selectedTab = "";
        this.closeNavBar.emit();
        break;
      case "appointments":
        this.slotService.isDeletedAppointments = false;
        this.closeNavBar.emit();
        break;
      default:
        this.closeNavBar.emit();
        break;
    }
  }
  isUserConsumer() {
    let index = -1;
    this.user = JSON.parse(localStorage.getItem("user"));
    if (this.user && this.user.companies && this.user.companies.length) {
      index = this.user.companies.findIndex((company) => company.consumer);
      if (index < 0 && this.user.type && this.user.type === "B2C") {
        index = 0;
      }
    }

    return index >= 0;
  }
  myProfile() {
    this.closeNav();
    let addDialog;
    if (window.innerWidth < 450 || window.innerHeight < 550) {
      addDialog = {
        width: "100vw",
        minWidth: "100vw",
        height: "100Vh",
      };
    } else if (window.innerWidth < 1100) {
      addDialog = {
        width: "45vh",
        minWidth: "450px",
        height: "55vh",
        minHeight: "500px",
        maxHeight: "620px",
      };
    } else {
      addDialog = {
        width: "36vw",
        minWidth: "450px",
        height: "83vh",
        minHeight: "450px",
        maxHeight: "500px",
      };
    }
    this.dialogService.openMatDialog(ProfileComponent, null, null, addDialog);
  }
  getStoresText() {
    return localStorage.getItem("retailerToken")
      ? "My " + this.storeText
      : "All " + this.storeText + "s";
  }
  changePassword() {
    this.closeNav();
    this.dialogService.openMatDialog(ChangePasswordComponent, null, true);
  }

  isRetailer() {
    return localStorage.getItem("retailerToken");
  }
}
